// Helper function to resolve image URLs
// Handles both absolute URLs and relative paths from uploads

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';

export const getImageUrl = (image) => {
  if (!image) return '';
  
  // If it's already an absolute URL, return as-is
  if (image.startsWith('http://') || image.startsWith('https://')) {
    return image;
  }
  
  // For relative paths (uploaded images), prepend the backend URL
  return `${BACKEND_URL}${image}`;
};

export default getImageUrl;
